import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import ThankYouScreen from '../../pages/mobile/sign-up/ThankYouScreen';
import ReferralScreen from '../../pages/mobile/referral/ReferralScreen';

function MobileReferralLayout() {

  return (
    <>
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
            <Switch>
              <Route path="/referral/thank-you">
                <ThankYouScreen />
              </Route>
              <Route path="/referral">
                <ReferralScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileReferralLayout;
